import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import { personalDetails } from "../Details";

function Home() {
  const { name, img } = personalDetails;
  const h11 = useRef();
  const h12 = useRef();
  const h13 = useRef();
  const myimageref = useRef();

  useEffect(() => {
    const tl = gsap.timeline();
    tl.from(h11.current, { x: "-100%", delay: 0.2, opacity: 0, duration: 2, ease: "Power3.easeOut" }, "<")
      .from(h12.current, { x: "-100%", delay: 0.5, opacity: 0, duration: 2, ease: "Power3.easeOut" }, "<")
      .from(h13.current, { x: "-100%", delay: 0.0, opacity: 0, duration: 2, ease: "Power3.easeOut" }, "<")
      .from(myimageref.current, { x: "200%", delay: 0.0, opacity: 0, duration: 2, ease: "Power3.easeOut" }, "<");
  }, []);

  return (
    <main className="max-width section md:flex justify-between items-center gap-10 md:px-28 lg:px-40 xl:px-52">
      <div className="text-center md:text-left md:max-w-xl flex-shrink-0">
        <h1
          ref={h11}
          className="text-3xl bg-clip-text bg-gradient text-transparent md:text-4xl xl:text-5xl xl:leading-tight font-bold"
        >
          {name}
        </h1>
        <h2
          ref={h12}
          className="text-xl text-dark-heading dark:text-light-heading md:text-2xl xl:text-3xl xl:leading-tight font-semibold mt-1"
        >
          Fullstack Engineer
        </h2>
        <p
          ref={h13}
          className="text-content text-sm md:text-base mt-4 leading-relaxed font-medium"
        >
          Production experience across TypeScript/React frontends, Python microservices, REST APIs, and cloud infrastructure on GCP and AWS. Currently the sole frontend developer on an enterprise dashboard serving all US Wendy's locations. Previously led engineering at an AI healthtech startup.
        </p>
      </div>
      <div className="flex justify-center mt-8 md:mt-0 md:justify-end flex-shrink-0">
        <img ref={myimageref} className="w-48 sm:w-56 md:w-64 lg:w-72 xl:w-80 rounded-2xl object-cover" src={img} alt="Billy Franklin" />
      </div>
    </main>
  );
}

export default Home;
